<template>
	<main>
		<div id="Login" class="set-bg-login height-100">
			<div class="set-div">
				<div class="col-sm-12">
					<div class="row" style="padding-left: 20px;">
						<div class="col-sm-2">
							<img alt="RTA Logo" src="./../assets/image/choah-logo-1.png" width="60px" />
						</div>
						<div class="col-sm-1">
            <!-- <b>SM & MA</b> -->
          </div>
          <div class="col-sm-8 font-14">
            <div class="set-1">
              <div class="f-logo "></div>
              <div class=" f-logo"><h5><b>Social Media & Messenger Analytic</b></h5></div>
            </div>
          </div>
					</div>
				</div>

				<form>
					<div class="col-sm-12 login-sm-4 shadow">
						<div class="input-group m-b-10">
							<div class="input-group-prepend">
								<span class="input-group-text" id="basic-addon1">
									<i class="icon-user" aria-hidden="true"></i>
								</span>
							</div>
							<input
								type="text"
								id="usr"
								class="form-control txt-field"
								placeholder="Username"
								autocomplete="username"
								aria-label="Username"
								aria-describedby="basic-addon1"
								v-model.trim="input.username"
							/>
						</div>
						<div class="input-group m-b-20">
							<div class="input-group-prepend">
								<span class="input-group-text" id="basic-addon1">
									<i class="icon-unlock-alt" aria-hidden="true"></i>
								</span>
							</div>
							<input
								type="password"
								class="form-control txt-field"
								placeholder="Password"
								autocomplete="current-password"
								v-model.trim="input.password"
								aria-label="Password"
								aria-describedby="basic-addon1"
							/>
						</div>
						<div>
							<button class="login-set cursor" @click.prevent="startlogin()">
								SIGN IN
								<i class="icon-sign-in" aria-hidden="true"></i>
							</button>
							<button class="btn-loading f-logo" type="button" disabled v-if="gifLoading">
								<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
								Loading ...
							</button>
							<div class="logError"></div>
						</div>
					</div>
				</form>
			</div>
			
		</div>
		<!-- MODAL -->
			<div class="modal" id="selectWorkspace" ref="selectWorkspace">
				<div class="modal-dialog">
					<div class="modal-content" style="width: 100%;transform: translate(0%, 45%);background: #353535;color: #fff;">
						<!-- Modal Header -->
						<div class="modal-header">
							<h6 class="modal-title">PLEASE SELECT WORKSPACE USERS</h6>
							<button type="button" class="close" data-dismiss="modal">&times;</button>

						</div>

						<!-- Modal body -->
						<div class="modal-body">
							<div class="row">
								<div class="col-md-12">
									<div class="list-workspace" v-for="(wrk, id) in this.list " :key="id" @click="showLoginMessage(wrk.id)">
										<span>{{wrk.name}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
    <!-- MODAL -->
	</main>
</template>


<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import $ from 'jquery';
export default {
	name: "login",
	data() {
		return {
			swork: false,
			input: {
				username: "",
				password: "",
			},
			list: [],
			gifLoading: false,
			loginMes:'',
			idWorkspace: '',
		};
	},
	computed: {
		...mapState('user', ['loginMessage', 'userLogin']),
		
	},
	methods: {
		...mapMutations('user', ['cleanMessage']),
		...mapActions('user', ['login']),
		startlogin() {
			this.hapusPesan();
			this.loginMes = "";
			if (this.input.username !== "" && this.input.password !== "") {
				this.gifLoading = true;
			
				const username = this.input.username;
				const password = this.input.password;
				this.login({ username, password })
					.then(async (e) => {
						console.log("masuk", e);
						if(e){
							this.list = this.userLogin.workspace;
							console.log(this.list.length)
							if(this.list.length > 1){
								this.swork = true;
								let element = await this.$refs.selectWorkspace;
								await $(element).modal('show')
							}else{
								this.swork = false;
								await this.showLoginMessage(this.list[0].id);
							}
							
						}else{
							await this.showLoginMessage(e);
							this.swork = false;
						}
						setTimeout(() => {
							this.gifLoading = false;
							this.input = { username: '', password: '' };
						}, 500);
					
					});

			}
		},
		showLoginMessage(e) {
			
			this.loginMes = this.loginMessage;
			let element = this.$refs.selectWorkspace;
			$(element).modal('hide')
			console.log("as", this.loginMes)
			// console.log(resp.data.data.workspace[0].id);
			sessionStorage.setItem("smcc-user", JSON.stringify({
				username: this.userLogin.username,
				level: this.userLogin.level,
				_w: e,
			}));
			if(this.loginMes === 'Login Success'){
				this.$router.push( '/' );
				setTimeout(() => {
					this.$swal({
						showConfirmButton: false,
						title: "Success!",
						text: "You success login",
						icon: "success",
						timer: 1000,
						button: false,
					})
				}, 500);
			}else{
				this.$router.push( '/signin' );
				setTimeout(() => {
					this.$swal({
						title: "Eror!",
						text: "Error login",
						icon: "error",
					})
				}, 1000);
			}
		},
		hapusPesan() {
			// this.$store.commit("cleanMessage");
			this.cleanMessage();
		},
	},
	mounted() {
    // console.log(localStorage.getItem('beer69_user'))
	},
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#login {
  font-family: Roboto, sans-serif;
}
.logError {
  padding-top: 10px;
  color: red;
  font-weight: bold;
}
</style>
